const columns = [
  { Header: 'Location', accessor: 'location' },
  { Header: 'Client Name', accessor: 'viaje_client_name' },
  { Header: 'In Shodan', accessor: 'in_shodan', type: 'boolean' },
  { Header: 'IP Address', accessor: 'ip_address' },
  { Header: 'Port', accessor: 'port' },
  { Header: 'OS', accessor: 'os' },
  { Header: 'System', accessor: 'system' },
  { Header: 'Product', accessor: 'product' },
  { Header: 'Product Version', accessor: 'product_version' },
  { Header: 'CVS Total Score', accessor: 'vulnerabilities_score' },
  { Header: 'Vulnerabilities Count', accessor: 'vulnerabilities_count' },
]

const vulnerabilitiesTableColumns = [
  { Header: 'CVS Score', accessor: 'cvs_score' },
  { Header: 'Summary', accessor: 'summary' }
]

export { columns, vulnerabilitiesTableColumns }